// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zLQQ","col":"styles_col__3Gwdt"};